export const formatDate = (timestamp) => {
  const date = timestamp.toDate();
  const day = date.getDate();
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const year = date.getFullYear().toString().padStart(2, '0');

  return `${day}.${month}.${year}`;
};
